// @flow
import * as React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Box } from 'grommet';
import { addBreadcrumb, removeBreadcrumb } from 'esm-web-pro/redux/breadcrumb';
import permissionRequired from 'esm-web-pro/decorators/permissionRequired';
import MapEditorSelector from 'esm-web-pro/containers/map/MapEditorSelector';
import CoverageTab from 'esm-web-pro/containers/pages/coverage/CoverageTab';


const MapDispatchToProps = ((dispatch) => (bindActionCreators({ addBreadcrumb, removeBreadcrumb }, dispatch)));

const messages = defineMessages({
    'coverage-page-title': {
        id: 'coverage-page-title',
        defaultMessage: 'Coverage',
    },
});

@connect(null, MapDispatchToProps)
@permissionRequired(['addresses.add_coverage'])
class CoveragePage extends React.Component<Object> {
    componentDidMount() {
        const {
            addBreadcrumb: addBreadcrumbAction, intl: { formatMessage },
        } = this.props;
        addBreadcrumbAction(formatMessage(messages['coverage-page-title']), '/addresses/coverage');
    }

    componentWillUnmount() {
        const {
            removeBreadcrumb: removeBreadcrumbAction, intl: { formatMessage },
        } = this.props;
        removeBreadcrumbAction(formatMessage(messages['coverage-page-title']));
    }

    render() {
        return (
            <Box height="100%">
                <MapEditorSelector
                    mapType="coverage"
                >
                    {(state) => (
                        <CoverageTab {...state} />
                    )}
                </MapEditorSelector>
            </Box>
        );
    }
}


export default injectIntl(CoveragePage);
